<template>
  <div class="newInfo_box">
    <sellheader></sellheader>
    <div class="content">
      <div
        :style="{ backgroundImage: 'url(' + backgroundImg + ')' }"
        style="background-size: cover; min-height: 300px; position: relative"
        class="inner-banner"
      >
        <section class="w3l-breadcrumb">
          <div class="container">
            <ul class="breadcrumbs-custom-path">
              <li><a href="./">首页</a></li>
              <li class="active">
                <a class="fa fa-chevron-right" href="/news">新闻中心</a>
              </li>
              <li class="active">
                <span class="fa fa-chevron-right mx-2" aria-hidden="true"></span
                >新闻详情
              </li>
            </ul>
          </div>
        </section>
      </div>
      <div class="new_info">
        <div class="new_title">
          <h3>{{newsInfo.newsTitle}}</h3>
        </div>
        <el-divider></el-divider>

        <div class="new_jian">
          <span class="time">发布时间：{{newsInfo.createTime}}</span>
          <span class="number"> 阅读：100 </span>
        </div>
        <div style="clear: both"></div>
        <el-divider></el-divider>
      </div>
      <div class="news_content">
        <p class="ql-editor" v-html="newsInfo.newsContent" style="text-align: left;"></p>
        
      </div>
      <div class="break">
        <router-link to="/news">
        <span>返回</span>
        </router-link>
        
      </div>
    </div>
    <footers></footers>
  </div>
</template>

<script>
import sellheader from "@/views/home/header/index.vue";
import footers from "@/views/footer/index.vue";
import {getNewsInfo} from "@/api/news/index"
import { bannerList } from "@/api/menu/index.js";
export default {
  components: {
    sellheader,
    footers,
  },
  data() {
    return {
      backgroundImg: "",
      newsInfo:{},
      newsInfoId:null,
      imgqueryParams: {
       picType:"news"
      },
    };
  },
  watch:{
},

  mounted() {
    this.getNewsInfo();
    this.getBannerList();
  },
  methods:{
    getBannerList(){
      bannerList(this.imgqueryParams).then(res =>{
        if(res.total > 0){
          this.backgroundImg = res.rows[0].picUrl
        }
        
      })
    },
    getNewsInfo(){
      getNewsInfo(this.getUrlKey("newsid")).then(res =>{
        this.newsInfo = res.data;
      })
    },
    
    getUrlKey (name) {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
}
  }
};
</script>

<style lang="less" scoped>

 .news_content /deep/ .ql-align-center{
  text-align: center;
}

.fa-chevron-right::before {
  font-size: 12px;
  margin-left: 10px;
  margin-right: 10px;
}
.content {
  padding-bottom: 60px;
}
.new_info {
  width: 80%;
  margin: auto;
  .new_title {
    width: 90%;
    height: 80px;
    margin: auto;
    h3 {
      text-align: center;
    }
  }
  .new_jian {
    width: 50%;
    margin: auto;
    .time {
      float: left;
    }
    .number {
      float: right;
    }
  }
}
.news_content {
  width: 80%;
  margin: auto;
  p {
    text-indent: 2em;
  }
}
.break {
  width: 70%;
  height: 50px;
  margin: 80px auto 10px auto;
  background: rosybrown;
  color: #fff;
  line-height: 50px;
  text-align: center;
  font-size: 18px;
}
@media (max-width: 992px) {
  .new_info .new_title {
    width: 98%;
    height: 50px;
    h3 {
      font-size: 17px;
    }
  }
  .new_info{
      width: 100%;
  }
  .new_info .new_jian{
      width: 85%;
  }
  .news_content{
      width: 90%;
  }
  .break{
      height: 50px;
      line-height: 50px;
  }
}
</style>